module.exports = __webpack_public_path__ + "img/x21.09d33391.jpg";